<template>
  <!-- 签署担保合同 -->
  <div>
    <div class="signingSecurityContractStyle">
      <div class="contentStyle">
        <component
          v-for="(app, index) in elementData[0].components"
          :is="app.component"
          :dataInfo="app"
          :key="index"
          :pageData="pageData"
        />
        <Contract :list="elementData[0].contracts" />
      </div>
      <div class="btnBox">
        <Button
          text="去签署"
          type="danger"
          class="nextStep"
          :click="goToNextPage"
        />
      </div>
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import Button from '@/components/Button.vue';
import Contract from '@/components/Contract.vue';
import ServerBank from '@/components/ServerBank.vue';
import ContractStatus from './components/ContractStatus.vue';
import TwoItemField from './components/TwoItemField.vue';
import TipsText from './components/TipsText.vue';

export default {
  name: 'signingSecurityContractStandard',
  data() {
    return {
      elementData: [{}],
      pageData: {},
    };
  },
  components: {
    Button,
    Contract,
    ServerBank,
    ContractStatus,
    TwoItemField,
    TipsText,
  },
  mounted() {
    this.getPageConfig();
  },
  methods: {

    ...mapMutations('commonForms', ['updateForm']),
    // 获取合同页配置
    getPageConfig() {
      // this.elementData = [
      //   {
      //     components: [
      //       {
      //         component: 'ContractStatus',
      //         label: '担保金支付状态：',
      //         key: 'securityStatus',
      //       },
      //       {
      //         component: 'TwoItemField',
      //         leftLabel: '担保金金额：',
      //         leftKey: 'securityAmount',
      //         leftMoneyFormat: true,
      //         rightLabel: '费率：',
      //         rightKey: 'securityRate',
      //         rightCompany: '%',
      //       },
      //       {
      //         component: 'TipsText',
      //         tipsText: '您的提款申请已审批通过，请先签署《担保服务合同》。',
      //       },
      //     ],
      //     contracts: [
      //       {
      //         text: '担保服务合同',
      //         value: 'spdb_guarantee',
      //       },
      //     ],
      //   },
      // ];
      // this.getContractInfo();
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$api.PublicPage.getProductConfig({
        pageId: this.$route.query.pageId, // 0:进件页面 1:授信合同签署页面 2:提款申请页面 3:提款合同签署页面 4:还款试算页面
        productId: this.$route.query.productId,
      }).then((res) => {
        if (res.success) {
          const result = JSON.parse(res.data[0].productConfigs);
          localStorage.setItem('configData', res.data[0].productConfigs);
          this.elementData = [...result];

          this.getContractInfo();
        }
      });
    },
    // 后端进行跳转
    jumpCurrPage() {
      const { orderId } = this.$route.query;
      this.$api.PublicPage.jumpCurrPage({
        orderId: orderId || localStorage.getItem('orderId'),
      }).then((res) => {
        if (res.success) {
          if (res.data) {
            window.location.href = res.data;
          }
        } else {
          this.$dialog.alert({
            title: '提示',
            message: '操作失败',
          });
        }
      });
    },
    // 查询合同信息
    async getContractInfo() {
      const { data, success, returnMessage } = await this.$api.OtherPage.queryEchoInfo({
        pageId: this.$route.query.pageId, // 0:进件页面 1:授信合同签署页面 2:提款申请页面 3:提款合同签署页面 4:还款试算页面 10:签署担保合同
        orderId: this.$route.query.orderId,
      });
      if (!success) {
        this.$toast(returnMessage || '获取数据失败');
        return;
      }
      this.$toast.clear();
      this.pageData = data;
      for (const i in this.elementData[0].components) {
        this.$set(this.elementData[0].components[i], 'value', data[this.elementData[0].components[i].key]);
      }
    },
    // 后端控制页面跳转
    goToNextPage() {
      if (this.pageData.url) {
        window.location.href = this.pageData.url;
        return;
      }
      this.$loading.show();
      const { orderId } = this.$route.query;
      if (orderId) {
        this.updateForm({
          orderId,
        });
      }
      this.$api.OtherPage.commitApply({
        orderId: orderId || localStorage.getItem('orderId'),
        pageId: this.$route.query.pageId, // 0:进件页面 1:授信合同签署页面 2:提款申请页面 3:提款合同签署页面 4:还款试算页面 10:签署担保合同
      }).then((res) => {
        this.$loading.hide();
        if (res.success) {
          this.jumpCurrPage();
        } else {
          this.$toast(res.returnMessage || '提交失败');
        }
      });
    },
  },
  computed: {
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
  },
};
</script>
<style lang="scss" scoped>
.signingSecurityContractStyle {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding: 15px;
  font-size: 15px;
  >>> .agreement {
    margin-left: 0px;
    margin-top: 20px;
  }
}
.contentStyle {
  box-shadow: border-box;
  padding-left: 40px;
  text-align: left;
}
.btnBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 15px;
}
.nextStep {
  width: 100%;
  padding: 0;
  border-radius: 3px;
  margin-top: 10px;
}
</style>
